/* src/app/PageNotFound.js */

import React from 'react';

const PageNotFound = () => (
  <div style={{ margin: 100 }}>The requested page was not found.</div>
);

export default PageNotFound;



// WEBPACK FOOTER //
// ./src/app/PageNotFound.js